function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconBuildingRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 28v-1c0-1.103-.897-2-2-2s-2 .897-2 2v1h4zm-2-5a4 4 0 014 4v3h-8v-3a4 4 0 014-4zM10 10h2V7h-2v3zM15 10h2V7h-2v3zM20 10h2V7h-2v3zM10 15h2v-3h-2v3zM15 15h2v-3h-2v3zM20 15h2v-3h-2v3zM10 20h2v-3h-2v3zM15 20h2v-3h-2v3zM20 20h2v-3h-2v3z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 2H7c-1.1 0-2 .9-2 2v24a2 2 0 002 2h3v-2H7V4h18v24h-3v2h3a2 2 0 002-2V4c0-1.1-.9-2-2-2z",
    fill: props.color
  }));
}

export default SvgIconBuildingRexOutline;